var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import { Heading, Button, Paragraph } from "@riseart/common";
import { artBioCuratorContactCls } from "./CuratorContact.less";
var DEFAULT_OPTIONS = {
  headingTag: "h3",
  headingLevel: 3,
  curatorContactButtonType: "secondary"
};
var ArtBioCuratorContact = /* @__PURE__ */ __name(function ArtBioCuratorContact2(_ref) {
  var title = _ref.title, text = _ref.text, buttonText = _ref.buttonText, _ref$buttonProps = _ref.buttonProps, buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options;
  return /* @__PURE__ */ React.createElement("section", {
    className: artBioCuratorContactCls
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: options.headingTag || DEFAULT_OPTIONS.headingTag,
    level: options.headingLevel || DEFAULT_OPTIONS.headingLevel
  }, title), /* @__PURE__ */ React.createElement(Paragraph, null, text), /* @__PURE__ */ React.createElement(Button, _extends({
    type: options.curatorContactButtonType || DEFAULT_OPTIONS.curatorContactButtonType
  }, buttonProps), buttonText));
}, "ArtBioCuratorContact");
export {
  ArtBioCuratorContact
};
